// Product-page enhancements load only when their element exists. Observe later section
// renders too; commerce and gallery controls are deliberately outside this small registry.
const registry = document.getElementById('pp-optional-modules');
if (registry) {
  const pending = new Map(Object.entries(JSON.parse(registry.textContent || '{}')));
  const scan = () => {
    for (const [selector, url] of pending) {
      if (!document.querySelector(selector)) continue;
      pending.delete(selector);
      import(url).catch((error) => console.warn('[Push Push] Optional component unavailable:', selector, error));
    }
    if (!pending.size) observer.disconnect();
  };
  const observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
  scan();
}
